import { TFileId, IDescriptionOfAspectRatio } from 'types';
import { ILoadFromFilePathOptions, IMaxFileSizeMB } from './formImageUploaderNewState/formImageUploaderNewContext';
import { MediaModal } from './components/MediaModal/MediaModal';
import { Uploader } from './components/Uploader';
import { UploaderHeader } from './components/UploaderHeader';
import { VideoCard } from './components/VideoCard';
import { ErrorModals } from './components/ErrorModals/ErrorModals';
import { FormImageUploaderNewState } from './formImageUploaderNewState/FormImageUploaderNewState';
import React from 'react';

interface IProps {
	setFileId: (fileId: Nullable<string>) => void;
	fileId: TFileId;
	deletePhotoHandler: () => void;
	horizontalAspectRatio?: number;
	verticalAspectRatio?: number;
	descriptionOfAspectRatio?: IDescriptionOfAspectRatio;
	maxWidth?: number;
	maxHeight?: number;
	maxFileSizeMB: IMaxFileSizeMB;
	containerClass?: string;
	noImageIconId?: string;
	loadFromFilePathOptions?: ILoadFromFilePathOptions; // Use for edit forms
	withValidation?: boolean;
	isRequired?: boolean;
	validationErrorTranslationKey?: string;
	validationFieldName?: string;
	infoContent?: React.ReactNode;
	modalTitleTranslationKey?: string;
	modalSubtitleTranslationKey?: string;
	cardTitleTranslationKey?: string;
	cardSubtitleTranslationKey?: string;
	setVideoFileId?: (fileId: TFileId) => void;
	deleteVideoHandler?: () => void;
	loadFromVideoFilePathOptions?: ILoadFromFilePathOptions;
	hasVideo?: boolean;
	setIsVideoActive?: (value: boolean) => void;
}

export const FormImageUploaderNew: React.FC<IProps> = ({
	setFileId,
	fileId,
	horizontalAspectRatio,
	verticalAspectRatio,
	descriptionOfAspectRatio,
	maxWidth,
	maxHeight,
	maxFileSizeMB,
	containerClass,
	noImageIconId,
	loadFromFilePathOptions,
	deletePhotoHandler,
	withValidation = false,
	isRequired,
	validationErrorTranslationKey,
	validationFieldName,
	infoContent,
	modalTitleTranslationKey,
	modalSubtitleTranslationKey,
	cardTitleTranslationKey,
	cardSubtitleTranslationKey,
	setVideoFileId,
	deleteVideoHandler,
	loadFromVideoFilePathOptions,
	hasVideo = false,
	setIsVideoActive,
}) => {
	return (
		<FormImageUploaderNewState setFileId={setFileId} setVideoFileId={setVideoFileId}>
			<div className="flex flex-col gap-4 w-full">
				{cardTitleTranslationKey && cardSubtitleTranslationKey && (
					<UploaderHeader
						titleTranslationKey={cardTitleTranslationKey}
						subtitleTranslationKey={cardSubtitleTranslationKey}
						maxFileSizeMB={maxFileSizeMB}
					/>
				)}
				{hasVideo ? (
					<VideoCard
						containerClass={containerClass}
						videoPath={loadFromVideoFilePathOptions?.filePath || ''}
						deleteVideoHandler={deleteVideoHandler}
						maxFileSizeMB={maxFileSizeMB}
					/>
				) : (
					<Uploader
						containerClass={containerClass}
						fileId={fileId}
						loadFromFilePathOptions={loadFromFilePathOptions}
						noImageIconId={noImageIconId}
						withValidation={withValidation}
						isRequired={isRequired}
						validationErrorTranslationKey={validationErrorTranslationKey}
						validationFieldName={validationFieldName}
						deletePhotoHandler={deletePhotoHandler}
						infoContent={infoContent}
						maxFileSizeMB={maxFileSizeMB}
					/>
				)}
			</div>
			<MediaModal
				maxFileSizeMB={maxFileSizeMB}
				loadFromFilePathOptions={loadFromFilePathOptions}
				horizontalAspectRatio={horizontalAspectRatio}
				verticalAspectRatio={verticalAspectRatio}
				maxHeight={maxHeight}
				maxWidth={maxWidth}
				noImageIconId={noImageIconId}
				descriptionOfAspectRatio={descriptionOfAspectRatio}
				modalTitleTranslationKey={modalTitleTranslationKey}
				modalSubtitleTranslationKey={modalSubtitleTranslationKey}
				loadFromVideoFilePathOptions={loadFromVideoFilePathOptions}
				hasVideo={hasVideo}
				setIsVideoActive={setIsVideoActive}
			/>
			<ErrorModals maxFileSizeMB={maxFileSizeMB} />
		</FormImageUploaderNewState>
	);
};
